import { useState, useMemo } from "react";
import { IconX } from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import NoDataFound from "../../../components/common/NoDataFound";

type DistrictItem = string;

type ViewDistrictModalProps = {
  open: boolean;
  onClose: () => void;
  districtItems?: DistrictItem[];
};

const ViewDistrictModal = ({
  open,
  onClose,
  districtItems = [],
}: ViewDistrictModalProps) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredDistricts = useMemo(() => {
    return districtItems.filter((d) =>
      d?.toLowerCase().includes(searchTerm?.toLowerCase())
    );
  }, [districtItems, searchTerm]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-[#F7F6F2] rounded-3xl w-[500px] max-h-[53vh] flex flex-col overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h2 className="text-lg font-medium text-[#212121]">
            View Districts ({filteredDistricts.length})
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-full border border-[#D2D2D2]"
          >
            <IconX size={20} />
          </button>
        </div>

        {/* Search */}
        <div className="px-4 py-3">
          <NormalSearch
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* District List */}
        <div className="flex-1 overflow-y-auto hide-scrollbar px-4 pb-4 space-y-1">
          {filteredDistricts.length > 0 ? (
            filteredDistricts.map((district, index) => (
              <div
                key={`${district}-${index}`}
                className="flex items-center gap-2 py-1"
              >
                <span className="h-8 w-8 flex justify-center items-center text-[#212121]/70 rounded-full border border-[#D2D2D2]">
                  {index + 1}
                </span>
                <p className="text-[#000000] text-base font-normal">
                  {district}
                </p>
              </div>
            ))
          ) : (
            <NoDataFound title="No Data Found" message="" />
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewDistrictModal;
